export const GROUND_COLORS = new Float32Array([
    0.173, 0.847, 0.7220001
]);

export const CASTLE_OUTER_COLORS = new Float32Array([
    0.816, 0.58, 0.42,
    0.84, 0.435, 0.305,
    0.169, 0.651, 0.667,
    0.571, 0.559, 0.736,
    0.878, 0.271, 0.271,
    0.58, 0.569, 0.769,
    0.949, 0.855, 0.631,
    0.173, 0.847, 0.722
]);

export const CASTLE_INNER_COLORS = new Float32Array([
    0.571, 0.559, 0.736,
    0.403, 0.39, 0.594,
    1, 0.392, 0.306,
    0.58, 0.569, 0.769,
    1, 1, 1,
    0.698, 0.316, 0.194,
    0.71, 0.701, 0.84,
    0.816, 0.58, 0.42,
    0.84, 0.435, 0.305,
    0.485, 0.668, 0.962,
    0.376, 0.376, 0.376,
    0.961, 0.843, 0.733,
    0.878, 0.271, 0.271,
    1, 0.42, 0.51,
    0.949, 0.855, 0.631,
    0.173, 0.847, 0.722,
    0.169, 0.651, 0.667
]);

export const BASE_COLORS = [
    [1, 1, 1], // day
    [0.1, 0.2, 0.7], // night
    [0.99, 0.42, 0.17], // sunrise
    [0.99, 0.19, 0.61] // sunset
];

export const AMBIENT = [
    0.45, // day
    0.25, // night
    0.35, // sunrise
    0.35 // sunset
];
